import React from 'react';

import { Box } from '@mui/material';

import * as environment from '@utils/environment';

function TermsAndConditionPage() {
	if (environment.env.FIRM_ENVIRONMENT === '9cap') {
		return (
			<Box>
				<p>
					<strong>Terms of Service.</strong>
				</p>
				<p>
					<strong>
						9Point Capital is an emerging digital platform that provides Indian investors seamless access to US and
						global stocks, mutual funds, and Digital Assets ETFs. Our mission is to simplify international investing
						through a user-friendly platform that allows individuals to diversify their portfolios globally while also
						ensuring that the Investments are safe and secure.At 9Point Capital, we prioritize investor protection above
						everything. We ensure that all products and services offered through our platform adhere to the highest
						regulatory standards to the extent possible, so our clients can invest with confidence. Our commitment to
						transparency and safeguarding investor interests sets us apart, making global markets and digital asset
						products not only accessible but also secure. Our platform enables investors to explore opportunities across
						some of the most dynamic and emerging markets and Industries. Whether you're an experienced investor or just
						starting out, 9Point Capital provides the guidance and tools necessary to make informed decisions and unlock
						the full potential of the global growth story.
					</strong>
				</p>
				<p>
					Please review these terms and conditions carefully. By accessing or utilizing the platform or application of
					VTI IFSC, which includes its affiliates and/or subsidiaries, as well as any related services, you acknowledge
					and agree to be bound by the terms outlined herein, including all terms incorporated by reference. Should you,
					referred to hereafter as the "Client" or "User," disagree with any of these terms, you are advised not to
					access or use the website, mobile application, or associated services. VTI IFSC reserves the exclusive right
					to modify these terms and conditions at its discretion. It is the user's responsibility to periodically review
					these terms to stay informed of any modifications. Continued use of the VTI IFSC platform and services
					following any modifications shall constitute the user's acceptance and agreement to the revised terms and
					conditions. Any updates or amendments to these terms shall become effective immediately upon publication.
				</p>
				<p>
					This document constitutes an electronic record as per applicable laws, as amended from time to time. For the
					purposes of these User Terms, "you," "your," or "User" shall refer to any natural or legal person, whether a
					registered user or otherwise, who accesses the Website, its contents, and utilizes the services offered by VTI
					IFSC.
				</p>
				<p>
					The information updated or provided on platform are verified and with best efforts basis, without any
					guarantee as to the accuracy of the data or information verifications. VTI IFSC shall not be held liable for
					any full or partial loss of the principal and/or interest of investment amounts.
				</p>
				<p>
					All investments in securities, bonds, MFs, ETFs are subject to market risk and there is possibility of loss of
					principal as well.
				</p>
				<p>
					<strong>Terms apply to whom</strong>
				</p>
				<p>
					This statement outlines the agreement that users enter into when they access or use the platform. By using the
					platform in any way&mdash;whether registering an account, signing up for services, or even just browsing as a
					guest&mdash;users agree to be bound by the terms and conditions set forth. It means that no matter how a user
					interacts with the platform, they are subject to the same rules and obligations outlined in these terms.
				</p>
				<p>
					<strong>Use of services with following condition</strong>
				</p>
				<ul>
					<li>
						Your right to use the services is contingent upon your full compliance with the terms and conditions set by
						the platform. If you violate any of these terms, your access to the services may be restricted or
						terminated. You are responsible for keeping your login credentials secure and ensuring that no one else
						accesses your account. The subscription is non-commercial, meaning you cannot use it for business purposes
						or any form of profit-making activity by subscribing it to others. This means that no one else, including
						family members, friends, or colleagues, is allowed to use your subscription. Failure to comply with these
						Terms at any time may result in the termination or suspension of your password, user account, and/or access
						to the Platform (in whole or in part) and/or the Services. We reserve the right to exercise such actions at
						our discretion. You carry responsibility for assessing the merits and risks associated with your use of the
						Platform, including any Content (as defined herein) and Services provided through the Platform. It is your
						duty to conduct such evaluations prior to making any investment, financial, or other decisions based on the
						information or services provided. We reserve the exclusive right, at our sole discretion and without prior
						notice or liability, to discontinue, modify, or alter any aspect of the Platform or our Services. This may
						include, but is not limited to, (i) limiting the availability of the Platform and/or any Service, (ii)
						imposing restrictions on the amount of use permitted, and (iii) restricting or terminating any user&rsquo;s
						access to the Platform and/or any of our Services. Additionally, you agree that we shall not be held liable
						to you or any third party for any termination, cancellation, or modification of your access to, or use of,
						the Platform and/or Services, as outlined in our applicable agreements with you. Furthermore, we shall not
						be liable for any technical malfunctions or errors, including any improper updates to data or information
						provided to you.
					</li>
				</ul>
				<p>
					<strong>Client&rsquo;s responsibilities</strong>
				</p>
				<p>
					Client Eligibility Criteria: The Client agrees to follow all the eligibility criteria as descried in
					applicable laws and regulations. If any investor is found to be ineligible or hiding any information with VTI
					IFSC or/and 9Point Capital, still made an investment in any plan or security, such an investment shall be
					deemed void in accordance with the terms and conditions of the investee entity.
				</p>
				<p>
					In connection with your use of our Services, including identification and billing purposes, you agree to
					provide true, accurate, and complete information as required during the subscription or sign-up process. This
					includes, but is not limited to, your legal name, address, telephone number, email address, and applicable
					billing information (collectively, "Subscription Data"), change in social security information (SS Number/Pan
					card/Aadhar number). You also consent to our sharing of your Subscription Data with third parties for the
					purposes of verifying the accuracy of the information provided and processing charges to your account. You are
					required to share any/all-important relevant information with us which is required to keep your account active
					with us as and when it changes or update.
				</p>
				<p>&nbsp;</p>
				<p>
					<strong>Restriction on Usage of Data</strong>
				</p>
				<p>
					While exploring or usage of data, material, information or any content of our platform in any other matter
					than agreement is prohibited to use at other. These materials are protected by copyrights, trademarks, and/or
					other proprietary rights. Such rights are valid and enforced across all current and future forms, media, and
					technologies. You are expressly prohibited from, and agree not to, download, display, or utilize any Mark in
					any publication, advertisement, publicity, or any other commercial or non-commercial context in connection
					with products or services that are not those of VTI IFSC&rsquo;s. You also agree not to use any Mark in a
					manner that is likely to cause consumer confusion, disparages or discredits VTI IFSC&rsquo;s or its software
					or intellectual property licensors, dilutes the strength of VTI IFSC&rsquo;s or its licensors&rsquo;
					intellectual property, or otherwise infringes upon the intellectual property rights of VTI IFSC&rsquo;s or its
					licensors. The Content is provided solely for personal and non-commercial access and use.
				</p>
				<p>
					<strong>Modification and Discretion Clause</strong>
				</p>
				<p>
					VTI IFSC&rsquo;s reserves the exclusive right, at its sole discretion, to amend, supplement, or otherwise
					modify the information, content, and terms of this Agreement at any time. Any such amendments or modifications
					shall be effective immediately upon posting on the Company&rsquo;s website. It is the sole responsibility of
					the User to review the terms regularly. Continued access to or use of the website by the User subsequent to
					any modifications shall constitute acceptance of such changes.
				</p>
				<p>
					Furthermore, VTI IFSC&rsquo;s retains the right to modify, suspend, discontinue, or terminate any service or
					part thereof at any time without prior notice. The Company may also, without prior notice, make alterations or
					adjustments to any content, products, or services available on the website.
				</p>
				<p>
					<strong>Copyright and Trademark Notice</strong>
				</p>
				<p>
					Except as otherwise expressly indicated, all copyrights and intellectual property rights in the materials
					presented on this Website, including but not limited to text, audio, video, and graphical images, as well as
					all trademarks and logos displayed herein, are the exclusive property of VTI IFSC&rsquo;s and/or proprietary
					firm of VTI IFSC&rsquo;s. These rights are protected under applicable Indian law. Any unauthorized use,
					reproduction, or infringement of these rights will be rigorously defended and prosecuted to the maximum extent
					permissible under the law.
				</p>
				<p>
					<strong>No Third-Party Beneficiary</strong>
				</p>
				<p>
					The User acknowledges and agrees that this Agreement shall not, under any circumstances, be construed as a
					third-party beneficiary contract. It is expressly understood that this Agreement is not intended to confer any
					rights or benefits upon any individual, entity, or company other than the Parties to this Agreement.
				</p>
				<p>
					<strong>Investment and Withdrawal Timeline Disclaimer</strong>
				</p>
				<p>
					The Client acknowledges that investment and withdrawal timelines are provided on a best-efforts basis, and VTI
					IFSC does not have control or discretionary power to affect or influence these timelines. The Client further
					understands that the effective date for their investment to begin accruing interest or returns is contingent
					upon the relevant platforms receiving all required information, including the in VTI IFSC&rsquo;s amount, in a
					timely manner. The Client accepts the risks and limitations associated with processing online transactions and
					agrees that VTI IFSC shall not be held liable for any delays in the effective date of their investment, the
					processing of their withdrawal request, or any other delays of any nature whatsoever.
				</p>
				<p>
					<strong>Advertising Disclaimer</strong>
				</p>
				<p>
					The Website may include advertising content and other materials submitted by third parties to VTI
					IFSC&rsquo;s. It is the sole responsibility of the advertisers to ensure that all materials submitted for
					inclusion on the Website comply with all applicable International and Indian laws. VTI IFSC&rsquo;s disclaims
					any liability for any claims, errors, omissions, or inaccuracies contained in any advertising material.
					Furthermore, VTI IFSC&rsquo;s reserves the right, at its sole discretion, to reject, suspend, or modify the
					placement or positioning of any advertising content submitted for inclusion on the Website. The acceptance of
					any advertisement on the Website is subject to the terms and conditions established by VTI IFSC&rsquo;s.
				</p>
				<p>
					<strong>Electronic Communications Clause</strong>
				</p>
				<p>
					The Platform facilitates electronic communication by providing you with our email address, allowing you to
					correspond with us by sending an email to{' '}
					<a href="mailto:grievances@9point.capital">grievances@9point.capital</a>.
				</p>
				<p>
					All communications shall be sent to the Client at the email address provided by the Client during the
					registration or account opening process. All communications share with client on restarted mail id, either
					received at client end or not, will be considered as client received it personally as a physical copy.
				</p>
				<p>
					<strong>Entire Agreement Clause</strong>
				</p>
				<p>
					This Agreement, together with the Website's Privacy Policy and Disclaimer, constitutes the complete and
					exclusive agreement between the User/Visitor and VTI IFSC&rsquo;s, superseding all prior or contemporaneous
					agreements, understandings, and communications, whether written or oral, between the Parties. Any amendment or
					modification to this Agreement shall only be effective if made in writing and duly executed by the authorized
					representatives of both Parties.
				</p>
				<p>
					<strong>Assignment Clause</strong>
				</p>
				<p>
					VTI IFSC reserves the right to assign any or all of its rights and obligations under this agreement to any
					third party without requiring the prior consent of, or notice to, the User.
				</p>
				<p>
					<strong>Operational and Regulatory Compliance</strong>
				</p>
				<p>
					VTI IFSC conducts its daily business operations from GIFT City and operates in accordance with the regulations
					set forth by the International Financial Services Centres Authority (IFSCA)<strong>. </strong>Any dispute
					arising between the Parties shall be subject to exclusive jurisdiction of the Singapore International
					Arbitration Centre (SIAC) only.
				</p>
				<p>
					<strong>Limitation of Liability Clause</strong>
				</p>
				<p>
					You expressly acknowledge and agree that neither we, nor our employee, directors, representatives, nor our
					holding company, shall be liable for any direct, indirect, incidental or special damages, or any other damages
					whatsoever, including but not limited to damages for loss of profits or principal capital.
				</p>
				<p>
					If you are dissatisfied with any portion of the Platform, or with any provision of this Agreement, your sole
					and exclusive remedy is to discontinue your use of the Platform. Our liability shall be limited to the extent
					permitted by law.
				</p>
				<p>
					<strong>Other Statutory Disclosure</strong>
				</p>
				<p>
					This website is being maintained and published by 9Point Capital. VTI IFSC is registered as Broker dealer with
					International Financial Services Centres Authority (IFSCA) and obtained No objection certificate from NSE IFSC
					for Global Market Access. By accepting these terms and conditions, the Client grants VTI IFSC&rsquo;s the
					authority to represent, act for, and on behalf of the Client for the purpose of facilitating the services. The
					Client further agrees that, upon acceptance of these terms and conditions, VTI IFSC&rsquo;s may provide any
					third-party executing transactions on behalf of the Client with a copy of this document as evidence of VTI
					IFSC&rsquo;s authority to act on the Client's behalf.
				</p>
				<p>
					<strong>Customer Complaints and Grievance Handling Policy</strong>
				</p>
				<p>
					All customer complaints and concerns related to the Company&rsquo;s activities, including any outsourced
					activities, will be addressed in accordance with this Policy. Customers may lodge complaints or grievances
					through the designated email address at{' '}
					<a href="mailto:grievances@9point.capital">grievances@9point.capital</a>, which will be prominently displayed
					on the Company's website, if applicable.
				</p>
				<p>
					Complaints received will be monitored and acknowledged by the client service team. Regardless of the method by
					which they are received, all complaints must be promptly reported to the CEO, along with supporting
					information and the outcome sought by the complainant and must be recorded in the complaints register.
				</p>
				<p>
					Complaint records will include the following information: (i) details of the complainant, (ii) mode of receipt
					of the complaint, (iii) nature of the complaint, (iv) outcome sought, (v) response time, (vi) person handling
					the complaint, (vii) status of the complaint&rsquo;s resolution, and (viii) any other relevant information.
				</p>
			</Box>
		);
	}

	return null;
}

export default TermsAndConditionPage;
